<template>
  <div style="background-color: #ffffff;width: 100vw;padding-bottom: 32px">
    <!--    <div style="position: relative">-->
    <!--      <van-swipe autoplay="3000" loop style="width: 100vw">-->
    <!--        <van-swipe-item v-for="(image, index) in images" :key="index" style="width: 100vw">-->
    <!--          <my-img :url="image" style="width: 100vw"/>-->
    <!--        </van-swipe-item>-->
    <!--      </van-swipe>-->
    <!--      <my-img style="width: 66%;position: absolute;top: 2px;left: 2px"-->
    <!--              url="https://cdn.keihong.tech/img/202408232318097.png"/>-->
    <!--      <div style="padding: 0 16px;position:absolute; bottom: -48px;left: 0" @click="onIntroClick">-->
    <!--        <my-img style="width: 100%;"-->
    <!--                url="https://cdn.keihong.tech/img/202411151731131.png"-->
    <!--        />-->
    <!--      </div>-->
    <!--    </div>-->
    <!--    <div style="height: 56px"></div>-->
    <div v-if="test">{{ test }}</div>
    <!--    <div>{{ hospital.name }}</div>-->
    <!-- 大云山封面 -->
    <div style="background-color: #fff;padding: 16px 16px 0 16px" @click="onIntroClick">
      <my-img url="https://cdn.keihong.tech/img/20250518130314433.png" style="width: 100%;border-radius: 8px;" />
    </div>
    <div style="background-color: #fff;padding: 16px 16px 0 16px" @click="onIntro2Click">
      <my-img url="https://cdn.keihong.tech/img/20250518130418596.png" style="width: 100%;border-radius: 8px;" />
    </div>
    <!-- 热门服务标题 -->
    <div class="section-title">特 色 产 品</div>

    <!-- 特色产品 start-->
    <div class="product-showcase">
      <!-- 产品图片轮播 -->
      <div class="product-swipe-container">
        <van-swipe class="product-swipe" :autoplay="4000" @change="onProductSwipeChange" :show-indicators="false">
          <van-swipe-item v-for="(image, index) in product.images" :key="index">
            <my-img :url="image" class="product-image"/>
          </van-swipe-item>
        </van-swipe>
        <div class="product-indicator">
          {{ productCurrentIndex + 1 }}/{{ product.images.length }}
        </div>
      </div>

      <!-- 产品详情 -->
      <div class="product-detail">
        <h3 class="product-title">{{ product.name }}</h3>
        <div class="product-tags">
          <span v-for="(tag, index) in product.tags" :key="index" class="product-tag">{{ tag }}</span>
        </div>
        <div class="product-description">{{ product.description }}</div>
        <div class="product-actions">
          <van-button type="primary" size="small" class="btn-article" @click="onIntro2Click">科普文章</van-button>
          <van-button type="primary" size="small" class="btn-video" @click="goToShortVideo">看短视频</van-button>
          <van-button type="primary" size="small" class="btn-book" @click="bookProduct(product)">预约到家</van-button>
        </div>
      </div>
    </div>
    <!-- 特色产品end -->

    <div class="section-title">全民主动健康/一起动起来</div>
    <!-- 轮播内容包装器 -->
    <div  class="banner-content-wrapper">
      <!-- 轮播图 -->
      <div class="banner" v-if="false">
        <div class="swipe-wrapper" >
          <van-swipe class="swipe-container" :autoplay="3000" @change="onChange" :show-indicators="false" ref="swipe">
            <van-swipe-item v-for="(banner, index) in bannerList"
                           :key="index"
                           @click="handleBannerClick(banner)">
              <my-img :url="banner.img" class="banner-image"/>
            </van-swipe-item>
          </van-swipe>
          <div class="custom-indicator">
            {{ current + 1 }}/{{ bannerList?.length || 0 }}
          </div>
        </div>
      </div>
      <!-- 轮播标题标签导航 -->
      <div class="banner-titles-wrapper" v-if="bannerList && bannerList.length > 0">
        <div class="banner-titles-container">
          <div
            v-for="(banner, index) in bannerList"
            :key="index"
            :class="['banner-title-bubble', { active: current === index }]"
            :style="getBubbleStyle(index)"
            @click="selectBanner(index)"
          >
            {{ banner.title || `轮播${index + 1}` }}
          </div>
        </div>
      </div>
    </div>

    <!-- 轮播图 end -->
     <!-- 功能按钮 start -->
    <div style="width: 100%;">
      <div class="section-title">健康科普</div>
      <FunctionNavDayunshan />
    </div>
     <!-- 功能按钮 end -->
    <div style="padding: 16px" v-show="false">
      <div class="func-wrapper">
        <div class="left">
          <!--          <img alt="Long Image 1" src="https://cdn.keihong.tech/img/202412091604195.png"/>-->
          <!--          <img alt="Long Image 1" src="https://cdn.keihong.tech/img/202412091604410.png"/>-->
          <my-img url="https://cdn.keihong.tech/img/202501051900022.png" @click.native="tapMdt"/>
          <my-img url="https://cdn.keihong.tech/img/202412091604410.png" @click.native="tapKepuxuanjiaoMainPage"/>
        </div>
        <div class="right">
          <my-img :url="homeRehabilitationImgUrl" @click.native="tapHomeRehabilitation"/>
          <my-img url="https://cdn.keihong.tech/img/202412091604431.png" @click.native="tapHomeCare"/>
          <my-img url="https://cdn.keihong.tech/img/202412091604490.png" @click.native="tapPlan"/>
          <my-img url="https://cdn.keihong.tech/img/202412091605494.png" @click.native="tapDaka"/>
          <my-img url="https://cdn.keihong.tech/img/202412091605199.png" @click.native="tapMall"/>
        </div>
      </div>
    </div>
    <!--    <div style="padding: 16px">-->
    <!--      <ServiceImageButtonGroup-->
    <!--        :leftImage="'https://cdn.keihong.tech/img/202411151758264.png'"-->
    <!--        :rightItems="serviceItems1"-->
    <!--      />-->
    <!--      <div style="height: 16px"/>-->
    <!--      <ServiceImageButtonGroup-->
    <!--        :left-link="'#/MallMainPageNeimeng?hospital=宏乾健康&type=护理康复服务'"-->
    <!--        :leftImage="'https://cdn.keihong.tech/img/202411151818876.png'"-->
    <!--        :rightItems="serviceItems2"-->
    <!--      />-->
    <!--      <div style="height: 16px"/>-->
    <!--      <ServiceImageButtonGroup-->
    <!--        :leftImage="'https://cdn.keihong.tech/img/202411151821222.png'"-->
    <!--        :rightItems="serviceItems3"-->
    <!--      />-->
    <!--    </div>-->
    <div class="doctor-list-wrapper">
      <div style="margin-bottom: 16px;font-size: 18px">{{ ' ' }}</div>
      <div v-if="hospital.video">
        <video
          :poster="hospital.video.cover"
          :src="hospital.video.url"
          class="video-player"
          controls
        ></video>
      </div>
      <my-img v-for="(doctor,index) in hospital.doctors" :key="index" :url="doctor.img"
              style="width: 100%;margin-bottom: 16px"/>
    </div>

    <div style="margin-top: 64px;font-size: 12px;color: #505050;text-align: center;margin-bottom: 16px">
      技术支持：动优科技
    </div>
  </div>

</template>
<script>
import MyImg from '@/h5/doucan/components/MyImg.vue'
import FunctionNavDayunshan from '@/h5/doucan/components/FunctionNavDayunshan.vue'
// 移除未使用的组件导入
// import ServiceImageButtonGroup from '@/h5/doucan/components/ServiceImageButtonGroup.vue'

export default {
  components: {
    // 移除未使用的组件注册
    // ServiceImageButtonGroup,
    MyImg,
    FunctionNavDayunshan
  },
  data () {
    return {
      test: '',
      current: 0,
      productCurrentIndex: 0,
      product: {
        id: '101',
        name: '芥麦叶',
        description: '芥麦叶性寒，在中医理论中归肝、胆、胃经。具有清热解毒、凉血止血功效。可用于治疗感冒发热、咳嗽等症状；《千金要方》也提及芥麦叶能应对温热引发的出血症状，这些记载为后研究与应用提供了重要依据。',
        tags: ['降糖降压降脂', '清热解毒', '中药材'],
        images: [
          'https://cdn.keihong.tech/img/20250518131717772.png',
          'https://cdn.keihong.tech/img/20250518131717772.png',
          'https://cdn.keihong.tech/img/20250518131717772.png'
        ]
      },
      // 大云山介绍文章id：
      introductionArticleId: 'dayunshan_101',
      bannerList: [
        {
          title: '八段锦',
          img: 'https://ihealthy.oss-cn-shenzhen.aliyuncs.com/%E5%85%BB%E6%8A%A4%E6%93%8D%E8%A7%86%E9%A2%91/%E5%81%A5%E8%BA%AB%E6%B0%94%E5%8A%9F/%E5%85%AB%E6%AE%B5%E9%94%A6/%E5%85%AB%E6%AE%B5%E9%94%A6%E5%B0%81%E9%9D%A2.png',
          articleId: 21
        },
        {
          title: '易筋经',
          img: 'https://ihealthy.oss-cn-shenzhen.aliyuncs.com/%E5%85%BB%E6%8A%A4%E6%93%8D%E8%A7%86%E9%A2%91/%E5%81%A5%E8%BA%AB%E6%B0%94%E5%8A%9F/%E6%98%93%E7%AD%8B%E7%BB%8F/%E6%98%93%E7%AD%8B%E7%BB%8F%E5%B0%81%E9%9D%A2.jpg',
          articleId: 22
        },
        {
          title: '康复科体操',
          img: 'https://ihealthy.oss-cn-shenzhen.aliyuncs.com/%E5%85%BB%E6%8A%A4%E6%93%8D%E8%A7%86%E9%A2%91/%E9%A1%BA%E5%BE%B7%E5%8C%BB%E9%99%A2/%E9%A1%BA%E5%BE%B7%E5%8C%BB%E9%99%A2%E4%BD%93%E6%93%8D%E4%B8%BB%E5%B0%81%E9%9D%A2.jpeg',
          articleId: 14
        },
        {
          title: '膝关节养护操',
          img: 'https://ihealthy.oss-cn-shenzhen.aliyuncs.com/pic/app%E5%86%85%E5%9B%BE/%E5%BA%B7%E5%A4%8D%E8%AE%AD%E7%BB%83%E6%93%8D%E5%B0%81%E9%9D%A2/%E8%86%9D%E5%85%B3%E8%8A%82%E5%85%BB%E6%8A%A4%E6%93%8D.jpg',
          articleId: 7
        },
        {
          title: '颈椎操',
          img: 'https://cdn.keihong.tech/img/202306141237303.png',
          articleId: 18
        },
        {
          title: '肩周炎医疗体操',
          img: 'https://cdn.keihong.tech/img/202306141236298.png',
          articleId: 15
        },
        {
          title: '腰椎间盘突出操',
          img: 'https://cdn.keihong.tech/img/202306141237356.png',
          articleId: 16
        },
        {
          title: '骨质疏松操',
          img: 'https://cdn.keihong.tech/img/202306141238980.png',
          articleId: 19
        },
        {
          title: '呼吸操-坐位',
          img: 'https://ihealthy.oss-cn-shenzhen.aliyuncs.com/pic/app%E5%86%85%E5%9B%BE/%E5%BA%B7%E5%A4%8D%E8%AE%AD%E7%BB%83%E6%93%8D%E5%B0%81%E9%9D%A2/%E5%91%BC%E5%90%B8%E6%93%8D-%E5%9D%90%E4%BD%8D.jpg',
          articleId: 4
        }
      ],
      images: [
        'https://cdn.keihong.tech/img/202411161337244.jpg',
        'https://cdn.keihong.tech/img/202411161337784.jpg',
        'https://cdn.keihong.tech/img/202411161337195.jpg'
      ],
      serviceItems1: [
        {
          image: 'https://cdn.keihong.tech/img/202411151803944.png',
          title: '',
          link: '#/LoginCheckPage?route=/JeilongDingcanPage'
        },
        {
          image: 'https://cdn.keihong.tech/img/202411151759609.png',
          title: '',
          link: '#/PingTuanHomePage'
        },
        {
          image: 'https://cdn.keihong.tech/img/202411151803888.png',
          title: '',
          link: '#/MallMainPageNeimeng?hospital=宏乾健康&mode=动优辅具&type=生活超市'
        }
      ],
      serviceItems2: [
        {
          image: 'https://cdn.keihong.tech/img/202411151819825.png',
          title: '',
          link: '#/MallMainPageNeimeng?hospital=宏乾健康&type=护理康复服务&select=上门护理'
        },
        {
          image: 'https://cdn.keihong.tech/img/202411161239029.png',
          title: '',
          link: '#/MallMainPageNeimeng?hospital=宏乾健康&type=护理康复服务&select=上门康复'
        },
        {
          image: 'https://cdn.keihong.tech/img/202411161240018.png',
          title: '',
          link: '#/MallMainPageNeimeng?hospital=宏乾健康&type=护理康复服务&select=社区康复'
        }
      ],
      serviceItems3: [
        {
          image: 'https://cdn.keihong.tech/img/202411151820537.png',
          title: '',
          link: '#/LoginCheckPage?route=/mdt/home'
        },
        {
          image: 'https://cdn.keihong.tech/img/202411151820016.png',
          title: '',
          link: '#/LoginCheckPage?route=/planListPage'
        },
        {
          image: 'https://cdn.keihong.tech/img/202411151821047.png',
          title: '',
          link: '#/LoginCheckPage?route=/PatientDataHomePage'
        }
      ],
      hospital: {
        id: 59,
        name: '霸桥区席王柴马社区卫生服务站',
        mainImg: 'https://cdn.keihong.tech/img/202412091556356.png',
        bannerList: [
          {
            title: '居家康复',
            img: 'https://cdn.keihong.tech/img/202411161337244.jpg',
            articleId: '1'
          },
          {
            title: '社区健康',
            img: 'https://cdn.keihong.tech/img/202411161337784.jpg',
            articleId: '2'
          },
          {
            title: '养老服务',
            img: 'https://cdn.keihong.tech/img/202411161337195.jpg',
            articleId: '3'
          }
        ],
        doctors: [
          {
            name: '',
            img: 'https://cdn.keihong.tech/img/202412091637331.png'
          },
          {
            name: '',
            img: 'https://cdn.keihong.tech/img/202412091639275.png'
          }
        ]
      }
    }
  },
  mounted () {
    console.log('社区主页', this.$route.query)
    if (this.$route.query.openid) {
      this.$store.commit('setIsWxapp', true)
      this.$store.commit('setWxAppOpenId', this.$route.query.openid)
      // this.test = this.$store.state.wxAppOpenId
    }
    let hospitalId = this.$route.query.hospitalId
    if (hospitalId) {
      console.log('hospitalId', this.$route.query.hospitalId)
      console.log('phone', this.$route.query.phone)
      this.$store.commit('user/setQrCodeHospitalId', this.$route.query.hospitalId)
    } else {
      hospitalId = this.$store.state.user.qrCodeHospitalId
    }
    this.hospital = this.getHospitalById(hospitalId)
    console.log('this.hospital', this.hospital)
    this.$store.commit('user/setQrCodeHospital', this.hospital.name)
    console.log(this.$store.state.user.qrCodeHospital)
    // this.hideLoading()
  },
  methods: {
    hideLoading () {
      this.$refs.container.stopLoading()
    },
    onProductSwipeChange (index) {
      this.productCurrentIndex = index
    },
    bookProduct (product) {
      // 使用Vue Router导航到商品详情页
      this.$router.push('/MallDetailPage?from=malllist&goodId=166')
    },
    goToProductDetail (product) {
      // 跳转到产品详情页，如果有文章ID则跳转到文章详情
      if (product.id) {
        this.$router.push({
          path: '/article/detail',
          query: { id: product.id }
        })
      } else {
        this.$toast({
          message: '产品详情正在完善中',
          position: 'middle',
          duration: 2000
        })
      }
    },
    // 新增：跳转到短视频页面的方法
    goToShortVideo () {
      // 这里假设短视频页面路由为 /shortvideo，可根据实际情况调整
      this.$router.push('/shortvideo')
    },
    getHospitalById (id) {
      const hospitalList = this.$store.state.miniappWebHospitalList.datas
      for (let i = 0; i < hospitalList.length; i++) {
        if (hospitalList[i].id === id) {
          return hospitalList[i]
        }
      }
      return null
    },
    // 大云山介绍
    onIntroClick () {
      this.$router.push({
        path: '/article/detail',
        query: { id: this.introductionArticleId }
      })
    },
    // 大云山文章列表
    onIntro2Click () {
      this.$router.push('/dayunshan/articles')
    },
    tapUndefined () {
      // 显示功能开发中的提示信息
      this.$toast({
        message: '功能正在开发中，敬请期待',
        position: 'middle',
        duration: 2000
      })
    },
    tapMdt () {
      const route = '/mdt/home'
      // this.$store.commit('setBack2', true)
      const isLogin = this.$store.state.user.profile.isLogin
      if (isLogin) {
        if (window.wx?.miniProgram) {
          window.wx.miniProgram.navigateTo({
            url: `/pages/mdt_list/mdt_list?from=web&phone=${this.$store.state.user.profile.phone}`
          })
        } else {
          this.$router.push(route)
        }
      } else {
        this.$router.push('/login/index')
      }
    },
    tapPlan () {
      const route = '/planListPage'
      // this.$store.commit('setBack2', true)
      const isLogin = this.$store.state.user.profile.isLogin
      if (isLogin) {
        this.$router.push(route)
      } else {
        this.$router.push('/login/index')
      }
    },
    tapDaka () {
      const route = '/PatientDataHomePage'
      // this.$store.commit('setBack2', true)
      const isLogin = this.$store.state.user.profile.isLogin
      if (isLogin) {
        this.$router.push(route)
      } else {
        this.$router.push('/login/index')
      }
    },
    tapMall () {
      const route = '/MallMainPageNeimeng'
      // this.$store.commit('setBack2', true)
      const isLogin = this.$store.state.user.profile.isLogin
      if (isLogin) {
        this.$router.push(route)
      } else {
        this.$router.push('/login/index')
      }
    },
    tapHomeCare () {
      const route = '/MallMainPageNeimeng?hospital=宏乾健康&type=护理康复服务&select=上门护理&notShowMenu=true'
      // this.$store.commit('setBack2', true)
      const isLogin = this.$store.state.user.profile.isLogin
      if (isLogin) {
        this.$router.push(route)
      } else {
        this.$router.push('/login/index')
      }
    },
    tapHomeRehabilitation () {
      let hospitalName = '宏乾健康'
      let select = '上门康复'
      if (this.hospital.id === '65') {
        hospitalName = this.hospital.name
        select = '居家康复'
      }
      console.log('hospitalName', hospitalName)
      const route = `/MallMainPageNeimeng?hospital=${hospitalName}&type=护理康复服务&select=${select}&notShowMenu=true`
      // this.$store.commit('setBack2', true)
      const isLogin = this.$store.state.user.profile.isLogin
      if (isLogin) {
        this.$router.push(route)
      } else {
        this.$router.push('/login/index')
      }
    },
    tapKepuxuanjiaoMainPage () {
      const route = '/KepuxuanjiaoMainPage'
      // this.$store.commit('setBack2', true)
      const isLogin = this.$store.state.user.profile.isLogin
      if (isLogin) {
        this.$router.push(route)
      } else {
        this.$router.push('/login/index')
      }
    },
    handleBannerClick (banner) {
      if (banner.articleId) {
        this.$router.push({
          path: '/TicaoDetailPage',
          query: {
            id: banner.articleId
          }
        })
      }
    },
    onChange (index) {
      this.current = index
    },
    selectBanner (index) {
      // 如果点击的是当前已选中的标签，执行跳转逻辑
      this.handleBannerClick(this.bannerList[index])
    },
    getBubbleStyle (index) {
      // 暖色调为主的颜色数组，绿色偏黄暖色
      const colors = [
        'linear-gradient(135deg, #A5D6A7 0%, #81C784 100%)', // 柔和绿
        'linear-gradient(135deg, #C5E1A5 0%, #9CCC65 100%)', // 嫩黄绿
        'linear-gradient(135deg, #E6EE9C 0%, #D4E157 100%)', // 柔和柠檬
        'linear-gradient(135deg, #FFECB3 0%, #FFD54F 100%)', // 柔和金色
        'linear-gradient(135deg, #FFCC80 0%, #FFB74D 100%)', // 淡橙色
        'linear-gradient(135deg, #DCEDC8 0%, #AED581 100%)', // 清新绿
        'linear-gradient(135deg, #F0F4C3 0%, #DCE775 100%)', // 淡黄绿
        'linear-gradient(135deg, #FFE0B2 0%, #FFCC80 100%)', // 淡橙色
        'linear-gradient(135deg, #FFF9C4 0%, #FFF176 100%)', // 淡黄色
        'linear-gradient(135deg, #B2DFDB 0%, #80CBC4 100%)', // 柔和青绿
        'linear-gradient(135deg, #C8E6C9 0%, #A5D6A7 100%)' // 柔和薄荷
      ]
      // 如果是当前选中的泡泡，返回空样式（使用.active中定义的样式）
      if (this.current === index) {
        return {}
      }
      // 根据索引选择颜色，循环使用颜色数组
      const colorIndex = index % colors.length
      const rotateValue = -1 + Math.random() * 2 // -1到1度之间的随机值
      const translateValue = Math.random() * 0.5 // 0到0.5像素之间的随机值
      return {
        background: colors[colorIndex],
        transform: `perspective(800px) rotateX(${rotateValue}deg) rotateY(${rotateValue}deg) translateZ(${translateValue}px)`,
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.06), inset 0 1px 2px rgba(255, 255, 255, 0.6)'
      }
    }
  },
  watch: {},
  computed: {
    homeRehabilitationImgUrl () {
      // 如果hospitalId为65，返回特定图片URL，否则返回默认URL
      return this.hospital && this.hospital.id === '65'
        ? 'https://cdn.keihong.tech/img/20250314161019943.png'
        : 'https://cdn.keihong.tech/img/202412091604589.png'
    }
  }
}
</script>
<style scoped>
.section-title {
  font-size: 18px;
  font-weight: 600;
  text-align: center;
  width: 100%;
  color: #333;
  margin-top: 32px;
  margin-bottom: 0;
}

.product-showcase {
  padding: 16px;
}

.product-swipe-container {
  position: relative;
  border-radius: 8px 8px 0 0;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.07);
  margin-bottom: 0;
}

.product-swipe {
  height: 240px;
  width: 100%;
  border-radius: 8px 8px 0 0;
  overflow: hidden;
}

.product-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.product-indicator {
  position: absolute;
  right: 10px;
  bottom: 10px;
  padding: 1px 10px;
  font-size: 11px;
  color: #008a43;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 16px;
  z-index: 2;
  letter-spacing: 1px;
}

.product-detail {
  background: #ffffff;
  border-radius: 0 0 8px 8px;
  padding: 16px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  margin-top: 0;
  position: relative;
  z-index: 1;
}

.product-title {
  font-size: 21.6px;
  font-weight: 600;
  color: #333;
  margin: 0 0 12px 0;
}

.product-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}

.product-tag {
  background: #f0f7f0;
  color: #008a43;
  font-size: 14.4px;
  padding: 2px 10px;
  border-radius: 12px;
  border: 1px solid #d0e8d0;
}

.product-description {
  font-size: 16.8px;
  color: #555;
  line-height: 1.6;
  margin-bottom: 16px;
}

.product-actions {
  display: flex;
  justify-content: space-between; /* 按钮均匀分布 */
  gap: 10px;
  width: 100%;
}
.btn-article {
  flex: 1 1 0;
  min-width: 0;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 8px;
  font-size: 16px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #4CAF50 0%, #2E7D32 100%) !important; /* 绿色渐变 */
  color: #fff !important;
  border: none !important;
  border-radius: 20px;
}
.btn-video {
  flex: 1 1 0;
  min-width: 0;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 8px;
  font-size: 16px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%) !important; /* 青绿色渐变 */
  color: #fff !important;
  border: none !important;
  border-radius: 20px;
}
.btn-book {
  flex: 1 1 0;
  min-width: 0;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 8px;
  font-size: 16px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #FF9800 0%, #FB8C00 100%) !important; /* 橙色渐变，购买暗示 */
  color: #fff !important;
  border: none !important;
  border-radius: 20px;
}

.func-wrapper {
  display: flex;
  gap: 8px;
  height: auto; /* 完全自适应高度 */
  min-height: 0; /* 移除最小高度限制，完全由内容决定高度 */
}

.left,
.right {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.left {
  flex: 7.6;
}

.right {
  flex: 11.1;
}

.left img,
.right img {
  width: 100%;
  object-fit: cover; /* 保证图片覆盖区域 */
  flex: 1; /* 均分父容器高度 */
}

.left img:first-child {
  flex: 1 1 50%; /* 第一个长图占据父容器的50% */
}

.right img {
  flex: 1 1 20%; /* 每个短图占据父容器的20% */
}

.doctor-list-wrapper {
  opacity: 1;
  background: linear-gradient(180deg, #FFFFFF 0%, #F9F9F9 10%, #F9F9F9 89%, #FFFFFF 100%);
  padding: 16px;
  position: relative;
  z-index: 1;
}

.video-player {
  width: 100%;
  aspect-ratio: 16/9;
  object-fit: cover;
  display: block;
  margin: 0 auto 16px;
  background-color: #000;
}

.banner-content-wrapper {
  padding: 0;
  width: 100%;
}

.banner {
  width: 100%;
  padding: 16px 16px 0;
  box-sizing: border-box;
}

.swipe-wrapper {
  position: relative;
  width: 100%;
  height: auto;
  border-radius: 8px;
  overflow: hidden;
}

.swipe-container {
  width: 100%;
  height: auto;
}

.banner-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.custom-indicator {
  position: absolute;
  right: 10px;
  bottom: 10px;
  padding: 1px 10px;
  font-size: 11px;
  color: #008a43;
  background: rgba(255, 255, 255, 0.692);
  border-radius: 16px;
  text-align: center;
  z-index: 2;
  letter-spacing: 1px;
}

.banner-titles-wrapper {
  width: 100%;
  padding: 0 16px 8px;
  box-sizing: border-box;
  margin-top: 12px;
}

.banner-titles-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  padding: 0;
}

.banner-title-bubble {
  border-radius: 20px;
  padding: 8px 14px;
  font-size: 13px;
  color: rgba(60, 60, 60, 0.9);
  text-align: center;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.165, 0.84, 0.44, 1);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08), inset 0 1px 1px rgba(255, 255, 255, 0.5);
  min-width: 0;
  transform: translateZ(0);
  backface-visibility: hidden;
  perspective: 1000px;
  position: relative;
  overflow: hidden;
  will-change: transform, box-shadow;
  border: 1px solid rgba(255, 255, 255, 0.3);
  text-shadow: none;
}

.banner-title-bubble::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 50%;
  background: linear-gradient(rgba(255, 255, 255, 0.35), rgba(255, 255, 255, 0));
  border-radius: 20px 20px 0 0;
  z-index: 1;
}

.banner-title-bubble::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 15%;
  background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.04));
  border-radius: 0 0 20px 20px;
  z-index: 1;
}

.banner-title-bubble:hover {
  transform: translateY(-2px) scale(1.02) translateZ(0.5px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1), inset 0 1px 2px rgba(255, 255, 255, 0.6);
}

.banner-title-bubble.active {
  background: linear-gradient(135deg, #FF9800 0%, #FB8C00 100%);
  color: white;
  font-weight: 600;
  box-shadow: 0 6px 12px rgba(251, 140, 0, 0.25), inset 0 1px 3px rgba(255, 255, 255, 0.5);
  transform: translateY(-2px) translateZ(1px);
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.3);
}
</style>
